import { Link } from "react-router-dom";
import { ArrowLeft, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/Seo";

const NotFoundPage = () => (
  <Layout showContactStrip={false}>
    <Seo title="Страницата не е намерена" path="/404" description="Търсената страница не съществува." noindex />
    <section className="min-h-[75vh] flex items-center pt-32 pb-20 bg-slate-50" data-testid="not-found-page">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#2E4A91]/10 flex items-center justify-center">
          <PhoneCall className="w-9 h-9 text-[#2E4A91]" />
        </div>
        <p className="text-8xl md:text-9xl font-extrabold text-[#2E4A91] tracking-tight">404</p>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mt-4">
          Тази линия е заета… или не съществува
        </h1>
        <p className="text-slate-600 mt-4 max-w-xl mx-auto">
          Страницата, която търсите, е преместена или адресът е грешен. Върнете се
          към началото или се свържете с нас.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link to="/">
            <Button className="btn-primary" data-testid="not-found-home-btn">
              <ArrowLeft className="mr-2 w-4 h-4" />
              Към началото
            </Button>
          </Link>
          <Link to="/kontakti">
            <Button variant="outline" className="btn-outline" data-testid="not-found-contact-btn">
              Контакти
            </Button>
          </Link>
        </div>
      </div>
    </section>
  </Layout>
);

export default NotFoundPage;
